import React from 'react';
import _ from 'lodash';

import Blocklink from '../../elements/Blocklink/Blocklink';
import Screen from '../Screen';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import UserLogo from '../../elements/UserLogo';

export default class EnrichmentsHomeListQuestions extends React.Component {
    componentDidMount() {
        this.props.notifications.forEach(notif => {
            app.api.notifications.markRead(notif.id);
        });
    }
    render() {
        var i18n = this.props.i18n,
            header = (
                <>
                    <TopBarEvent returnURL={this.props.returnURL} event={this.props.event}>
                        {this.props.headerTitle}
                    </TopBarEvent>
                    <UserLogo user={this.props.user} profileUrl="./my_profile" />
                    <hr />
                </>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <div className="content">
                        <p>{this.props.introText}</p>
                    </div>
                    <div>
                        <br />{' '}
                        {this.props.questions.map(question => {
                            var answer, customColor;
                            if (question.question.answer_type == 'options') {
                                answer = (
                                    <div>
                                        {question.answer.map((value, i) => {
                                            var option = _(question.question.options).find({value});
                                            if (option) {
                                                return <div key={i}>{option.label}</div>;
                                            }
                                        })}
                                    </div>
                                );
                            } else {
                                answer = question.answer ? question.answer.join(', ') : null;
                            }
                            if (!answer) {
                                customColor = this.props.headerColor;
                            }

                            if (!question.answer || !question.answer.length || question.question.editable) {
                                return (
                                    <Blocklink
                                        key={question.id}
                                        next="next"
                                        href={['.', 'question', question.id].join('/')}
                                        color="gray"
                                        customColor={customColor}>
                                        {question.question.text}
                                        <div className="subtitle">{answer}</div>
                                    </Blocklink>
                                );
                            } else {
                                return (
                                    <Blocklink
                                        key={question.id}
                                        color="gray"
                                        customColor={customColor}
                                        style={{
                                            pointerEvents: 'none',
                                        }}>
                                        {question.question.text}
                                        <div className="subtitle">{answer}</div>
                                    </Blocklink>
                                );
                            }
                        })}
                    </div>
                </Scrollable>
            </Screen>
        );
    }
}
